<div class="py-4">
  <div class="flex flex-col">
    <a class="py-2 px-10 hover:bg-gray-200" routerLink="">Home</a>
    <a class="py-2 px-10 hover:bg-gray-200" routerLink="/route-one"
      >&nbsp;&nbsp;- Route One</a
    >
    <a class="py-2 px-10 hover:bg-gray-200" routerLink="/route-two"
      >&nbsp;&nbsp;- Route Two</a
    >
    <a class="py-2 px-10 hover:bg-gray-200" routerLink="/route-three"
      >&nbsp;&nbsp;- Route Three</a
    >
    <a class="py-2 px-10 hover:bg-gray-200" routerLink="/route-params/hello"
      >&nbsp;&nbsp;- Route Params</a
    >
    <a class="py-2 px-10 hover:bg-gray-200" routerLink="/route-guard"
      >&nbsp;&nbsp;- Route Guard</a
    >
    <a
      class="py-2 px-10 hover:bg-gray-200"
      routerLink="/route-query-params"
      [queryParams]="routeQueryParmas"
      >&nbsp;&nbsp;- Route Query Params</a
    >
    <a class="py-2 px-10 hover:bg-gray-200" routerLink="/route-data"
      >&nbsp;&nbsp;- Route Data</a
    >
    <a class="py-2 px-10 hover:bg-gray-200" routerLink="/route-stand-alone"
      >&nbsp;&nbsp;- Standalone Route</a
    >
    <a class="py-2 px-10 hover:bg-gray-200" routerLink="/feature/main"
      >&nbsp;&nbsp;- Feature Main</a
    >
    <a class="py-2 px-10 hover:bg-gray-200" routerLink="/feature/main/one">
      &nbsp;&nbsp;&nbsp;&nbsp;- Feature Route One</a
    >
    <a class="py-2 px-10 hover:bg-gray-200" routerLink="/feature/main/two">
      &nbsp;&nbsp;&nbsp;&nbsp;- Feature Route Two</a
    >
    <a class="py-2 px-10 hover:bg-gray-200" routerLink="/feature/main/three">
      &nbsp;&nbsp;&nbsp;&nbsp;- Feature Route Three</a
    >
    <a class="py-2 px-10 hover:bg-gray-200" routerLink="/feature/team"
      >&nbsp;&nbsp;- Feature Team</a
    >
    <a class="py-2 px-10 hover:bg-gray-200" routerLink="/feature/team/member/1">
      &nbsp;&nbsp;&nbsp;&nbsp;- Feature Team meamber</a
    >
    <a class="py-2 px-10 hover:bg-gray-200" routerLink="/feature/team/match/12">
      &nbsp;&nbsp;&nbsp;&nbsp;- Feature Team Match</a
    >
    <a class="py-2 px-10 hover:bg-gray-200" routerLink="/feature/team/admin">
      &nbsp;&nbsp;&nbsp;&nbsp;- Feature Team Admin</a
    >
  </div>
</div>
